import { CreateButton, ExportButton, TopToolbar } from "react-admin";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { ReactComponent as ExportIcon } from "../../../assets/icons/Export.svg";

const ListActions = ({ types = ["Create", "Export"], labelCreate, labelExport }) => {
  return (
    <TopToolbar style={{marginRight: 15}}>
      {types.map((type) => {
        return (
          <>
            {type === "Create" ? (
                <CreateButton
                  icon={<AddCircleIcon width={20} height={20} />}
                  label={labelCreate}
                />
            ) : type === "Export" ? (
                <ExportButton
                  icon={<ExportIcon width={20} height={20} />}
                  label={labelExport}
                />
            ) : type === "Import" ? (
              <></>
            ) : (
              <></>
            )}
          </>
        );
      })}
    </TopToolbar>
  );
};
export default ListActions;
